export const MISSION_STATUSES = ['cree', 'affectee', 'en_cours', 'terminee'];

export const PHOTO_LABELS = [
  'Profil gauche - Vue laterale complete cote conducteur',
  'Profil droit - Vue laterale complete cote passager',
  'Face avant - Vue frontale complete du vehicule',
  'Face arriere - Vue arriere complete du vehicule',
  '3/4 avant gauche - Vue diagonale avant gauche',
  '3/4 avant droit - Vue diagonale avant droite',
  '3/4 arriere gauche - Vue diagonale arriere gauche',
  '3/4 arriere droit - Vue diagonale arriere droite',
  'Toit - Vue du dessus',
  'Dessous - Vue du chassis',
  'Interieur general',
  'Coffre ou hayon',
  'Pare-chocs avant',
  'Calandre',
  'Phares avant',
  'Feux de position avant',
  'Capot',
  'Pare-brise',
  'Retroviseurs exterieurs',
  'Cotes du vehicule',
  'Portiere avant gauche',
  'Portiere avant droite',
  'Portiere arriere gauche',
  'Portiere arriere droite',
  'Vitres laterales',
  'Montants de portes',
  'Passages de roues',
  'Pare-chocs arriere',
  'Feux arriere',
  'Hayon ou coffre',
  'Lunette arriere',
  'Plaque dimmatriculation',
  'Echappement',
  'Roue avant gauche',
  'Roue avant droite',
  'Roue arriere gauche',
  'Roue arriere droite',
  'Tableau de bord',
  'Compteurs - Kilometrage et temoins',
  'Volant - Etat et commandes',
  'Levier de vitesse',
  'Frein a main',
  'Pedalier',
  'Console centrale',
  'Siege conducteur - Vue complete',
  'Siege passager avant - Vue complete',
  'Banquette arriere - Vue complete',
  'Garnitures de portes - Interieur',
  'Pavillon - Ciel de toit et eclairage',
  'Tapis de sol',
  'Ceintures de securite',
  'Vue ensemble moteur',
  'Bloc moteur',
  'Batterie',
  'Radiateur',
  'Courroies',
  'Reservoirs - Liquide de frein et direction',
  'Filtres - Air et autres',
  'Etiquette constructeur - Plaque signaletique moteur',
  'Plaque constructeur',
  'Numero VIN',
  'Etiquette pression pneus',
  'Impacts - Chocs rayures et deformtions',
  'Peinture - Eclats corrosion decoloration',
  'Vitres - Fissures eclats bris',
  'Eclairage - Cassures ou oxydation',
  'Plastiques - Fissures ou decolorations',
  'Mecaniques - Fuites ou deformtions',
  'Angles multiples - Dommages sous differents angles',
  'Freinage - Disques et plaquettes',
  'Direction - Jeu et fixations',
  'Suspension - Amortisseurs et ressorts',
  'Echappement - Fixations et corrosion',
  'Eclairage - Controle du fonctionnement',
  'Signalisation - Clignotants et warnings',
];

export const DAMAGE_PARTS = [
  'Pare-chocs avant (coque)',
  'Pare-chocs arrière (coque)',
  'Renfort de pare-chocs',
  'Absorbeur de pare-chocs (mousse)',
  'Supports / glissières de pare-chocs',
  'Grille de calandre',
  'Grilles latérales',
  'Inserts de pare-chocs',
  'Spoiler / lèvre avant',
  'Diffuseur arrière',
  'Baguettes de pare-chocs',
  'Passage de roue / pare-boue',
  'Sabot moteur / protection sous moteur',
  'Déflecteurs d’air',
  'Cache sous pare-chocs',
  'Aile avant',
  'Aile arrière',
  'Capot',
  'Hayon',
  'Coffre / malle arrière',
  'Porte avant',
  'Porte arrière',
  'Bas de caisse',
  'Jupe latérale',
  'Toit / pavillon',
  'Trappe à carburant',
  'Charnières (portes, capot, hayon)',
  'Joints extérieurs',
  'Pare-brise',
  'Lunette arrière',
  'Vitres latérales',
  'Custodes',
  'Phare avant',
  'Feu arrière',
  'Antibrouillard',
  'Clignotants',
  'Feux diurnes (DRL)',
  'Troisième feu stop',
  'Catadioptres',
  'Éclairage de plaque',
  'Rétroviseur complet',
  'Glace de rétroviseur',
  'Support de rétroviseur',
  'Poignées de porte',
  'Serrures / actuateurs',
  'Antenne',
  'Barres / rails de toit',
  'Bras d’essuie-glace',
  'Balais d’essuie-glace',
  'Tringlerie d’essuie-glace',
  'Moteur d’essuie-glace',
  'Gicleurs lave-glace',
  'Pompe lave-glace',
  'Réservoir lave-glace',
  'Caméra avant',
  'Caméra arrière',
  'Capteurs de stationnement',
  'Radar avant',
  'Radiateur moteur',
  'Condenseur de climatisation',
  'Intercooler',
  'Ventilateur de refroidissement',
  'Cadre de ventilateur',
  'Support radiateur / façade avant',
  'Durites de refroidissement',
  'Boîtier thermostat',
  'Durites d’admission / suralimentation',
  'Sondes / capteurs moteur',
  'Longerons',
  'Traverses',
  'Berceau avant',
  'Berceau arrière',
  'Plancher',
  'Tablier',
  'Passage de roue (structure)',
  'Montants (A/B/C)',
  'Renforts de caisse',
  'Supports moteur',
  'Supports boîte',
  'Triangle / bras de suspension',
  'Silentblocs',
  'Rotules',
  'Biellette de direction',
  'Rotule axiale',
  'Crémaillère de direction',
  'Colonne de direction',
  'Amortisseur',
  'Ressort',
  'Coupelle d’amortisseur',
  'Butée d’amortisseur',
  'Moyeu',
  'Roulement de roue',
  'Porte-moyeu / fusée',
  'Cardan',
  'Arbre de transmission',
  'Différentiel',
  'Barre stabilisatrice',
  'Biellette de barre stabilisatrice',
  'Disque de frein',
  'Plaquettes de frein',
  'Étrier de frein',
  'Flexible de frein',
  'Canalisation de frein',
  'Capteur ABS',
  'Bloc ABS / ESP',
  'Maître-cylindre',
  'Frein de parking / EPB',
  'Jante',
  'Pneumatique',
  'Valve',
  'Capteur TPMS',
  'Enjoliveur',
  'Carter d’huile',
  'Carter de boîte',
  'Batterie',
  'Bac batterie',
  'Faisceau moteur',
  'Boîtier fusibles',
  'Connecteurs électriques',
  'Ligne d’échappement',
  'Silencieux arrière',
  'Silencieux intermédiaire',
  'Catalyseur',
  'FAP / DPF',
  'Supports d’échappement',
  'Sonde lambda',
  'Réservoir carburant',
  'Goulotte de remplissage',
  'Pompe à carburant',
  'Module jauge',
  'Canister EVAP',
  'Durites carburant',
  'Airbag conducteur',
  'Airbag passager',
  'Airbags latéraux',
  'Airbags rideaux',
  'Airbag genoux',
  'Calculateur airbag (SRS)',
  'Capteurs de choc',
  'Prétensionneurs',
  'Ceintures de sécurité',
  'Contacteur tournant (clock spring)',
  'Tableau de bord',
  'Console centrale',
  'Boîte à gants',
  'Garnitures de porte',
  'Clips / agrafes',
  'Lève-vitre',
  'Moteur lève-vitre',
  'Serrure intérieure',
  'Siège',
  'Rails de siège',
  'Moquette',
  'Insonorisants',
  'Radars ADAS',
  'Caméra pare-brise',
  'Modules ADAS',
  'Supports de calibration',
  'Faisceaux pare-chocs',
  'Tuyaux de climatisation',
  'Compresseur de climatisation',
  'Radiateur de chauffage',
  'Visserie',
  'Rivets',
  'Inserts',
  'Supports / équerres',
  'Guides',
  'Butées',
  'Câbles d’ouverture capot',
  'Câbles trappe carburant',
];

export const DAMAGE_TYPE_OPTIONS = [
  { value: 'original', label: 'Original' },
  { value: 'reparation', label: 'Reparation' },
  { value: 'reccuperation', label: 'Reccuperation' },
  { value: 'adaptation', label: 'Adaptation' },
  { value: 'produit_peinture', label: 'Produit peinture' },
];

export const LABOR_CATEGORIES = [
  { id: 'tolerie_changement', label: 'Tôlerie (changement)' },
  { id: 'tolerie_dressage', label: 'Tôlerie (dressage)' },
  { id: 'peinture', label: 'Peinture' },
  { id: 'mecanique', label: 'Mécanique' },
  { id: 'electricite', label: 'Électricité' },
  { id: 'bris_glace', label: 'Bris de glace' },
];
